module.exports = __webpack_public_path__ + "2ccfefa9c6f46fed181964dd89d050e7.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/leaf-icon.png
 ** module id = 459
 ** module chunks = 0
 **/